import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a video popup
 *
 * Functionality is now rolled into the media hotspot
 */
export default class VideoHotspot extends BaseHotspot {
  /**
   * Initialises an video hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'video',
   *   options: {
   *     title: 'Title',
   *     video_type: 'mp4',
   *     url: 'http://example.com/video.mp4'
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadTexture({
      url: `${window.location.origin}/tour/assets/hotspots/video.png`,
    });

    this._config = config;
  }
}
